export const DEFAULT_PRIVATE_PACK_DESCRIPTION =
  '[{"type":"paragraph","children":[{"text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at fermentum orci, vitae tempus augue. Etiam iaculis blandit condimentum."}]}]';